module.exports = __webpack_public_path__ + "img/用数字化构建产业新生态.2230b6aa.png";